import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { App } from 'data/terra/App';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { AppSelectorState } from '../reducer';

export const FETCH_APPS = 'FETCH_APPS';

export interface FetchAppsAction {
  type: typeof FETCH_APPS;
  apps: App[];
}

export const fetchApps = (
  productId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  const result = await Terra.app.fetchApps(productId);
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_APPS,
      apps: result.get()!.data,
    } as FetchAppsAction);
  }

  return result;
};

export const fetchAppsDelegate: DelegateMapEntry<
  FetchAppsAction,
  AppSelectorState
> = {
  [FETCH_APPS]: (
    state: AppSelectorState,
    action: FetchAppsAction
  ): AppSelectorState => {
    return {
      ...state,
      apps: action.apps,
    };
  },
};
